<template>
  <div>
    <div class="evaluationPeport_main" v-if="version">
      <div class="title">
        {{this.$route.query.name||''}}生涯测评报告
      </div>
      <div v-if="version==1">
        <div>
          <div class="partTitle">人格特性</div>
          <keep-alive>
            <Rgtx v-if="reportId" :reportId="reportId"></Rgtx>
          </keep-alive>
        </div>
        <div>
          <div class="partTitle">智能水平</div>
          <Rzqn v-if="reportId" :reportId="reportId"></Rzqn>
        </div>
        <div>
          <div class="partTitle">兴趣倾向</div>
          <Xqqx v-if="reportId" :reportId="reportId"></Xqqx>
        </div>
        <div>
          <div class="partTitle">职业价值观</div>
          <Zysy v-if="reportId" :reportId="reportId"></Zysy>
        </div>
        <div>
          <div class="partTitle">心理适应性</div>
          <Xljk v-if="reportId" :reportId="reportId"></Xljk>
        </div>
      </div>
      <div v-if="version==2">
        <div>
          <div class="partTitle">人格特性</div>
          <keep-alive>
            <Rgtx2 :mbti="mbti"></Rgtx2>
          </keep-alive>
        </div>
        <div>
          <div class="partTitle">智能水平</div>
          <keep-alive>
            <Znsp2 :intelligent="intelligent"></Znsp2>
          </keep-alive>
        </div>
        <div>
            <div class="partTitle" style="margin-top: 20px">兴趣倾向</div>
          <keep-alive>
            <Xqqx2 :hobby="hobby" :radarChart="radarChart"></Xqqx2>
          </keep-alive>
        </div>
        <div>
          <div class="partTitle" style="margin-top: 20px">职业价值观</div>
          <keep-alive>
            <Zyjzg2 :profession="profession"></Zyjzg2>
          </keep-alive>
        </div>
        <div>
          <div class="partTitle" style="margin-top: 20px">心理适应性</div>
          <keep-alive>
            <Xlsyx2 :mind="mind" :result='result'></Xlsyx2>
          </keep-alive>
        </div>
      </div>
      <!-- <div class="evaluation_button" @click="$router.go(-1)" style="margin-top: 50px" v-if="!componentId">
        返回
      </div> -->
      <div class="evaluation_button" @click="$router.go(-1)" style="margin-top: 50px">
        返回
      </div>
    </div>
    <div v-else class="noContent">
        <NoContent></NoContent>
    </div>
  </div>
</template>
<script>
 import NoContent from "@/components/NoContent.vue";
//旧
import Rgtx from './components/evalutionReport/rgtx'
import Zysy from './components/evalutionReport/zysy'
import Xqqx from './components/evalutionReport/xqqx'
import Zyzytj from './components/evalutionReport/zyzytj'
import Rzqn from './components/evalutionReport/rzqn'
import Xljk from './components/evalutionReport/xljk'

//新
import Rgtx2 from './components/evalutionReport2/rgtx'
import Znsp2 from './components/evalutionReport2/znsp'
import Xqqx2 from './components/evalutionReport2/xqqx'
import Zyjzg2 from './components/evalutionReport2/zyjzg'
import Xlsyx2 from './components/evalutionReport2/xlsyx'
export default {
  name: "evaluationReport",
  props:['componentId','componentName'],
  data(){
    return {
      reportId:'',
      version:'',
      mbti:{},
      intelligent:[],
      hobby:{},
      radarChart:[],
      radarValue:[],
      profession: {}, //职业倾向
      mind:{},
      result:[],
      bgArr: [], //八卦
      bgNewArr:["R-实际型","C-传统型","E-企业型","S-社会型","A-艺术型","I-研究型"],
      bgNewArr2:[],
    }
  },
  components:{Rgtx2,Znsp2,Xqqx2,Zyjzg2,Xlsyx2,Rgtx,Zysy,Xqqx,Zyzytj,Xljk,Rzqn,NoContent},
  methods:{
    toParent(){
      this.$emit('event1','>测评报告')
    },
    judgeNewOld(){
      this.$ajax.post(this.G_acapi + this.ports.consultant.student.report.judge,{
        studentId:this.$route.query.studentId||this.componentId
      },{
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then(res=>{
        if(res.data.code==2000){
          this.version=res.data.data.career.version;
          this.reportId=res.data.data.career.reportId;
          // this.version=2;
          // this.reportId='02b4998babda49d58a0a7bb7c3c6211a';
          console.log(res,'data')
          if(this.version == 2){
              this.getReportData(this.reportId)
          }
        }else{
          
        }
      })
    },

    getReportData(id){
      this.$ajax.post(this.G_capi + this.ports.consultant.student.report.newReportData,{
        reportId: id,

      },{
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then(res=>{
        if(res.data.code==2000){
          console.log(res)
          this.mbti = res.data.data.mbti; //人格特性
          this.intelligent = res.data.data.intelligent; //智能水平
          this.hobby = res.data.data.hobby; //兴趣倾向
          this.radarChart = res.data.data.hobby.radarChart
          this.threeYard = res.data.data.hobby.threeYard
           this.profession = res.data.data.profession; //职业价值观
          this.mind = res.data.data.mind; //心里适应性
          this.result = res.data.data.mind.result
          for (var i = 0; i < this.radarChart.length; i++) {
            this.bgArr.push({
              name: this.radarChart[i].type + "-" + this.radarChart[i].name,
              value: this.radarChart[i].value,
              max: 20,
              type: this.radarChart[i].type
            });
          }

          for (var i = 0; i < this.threeYard.length; i++) {
            for (var j = 0; j < this.bgArr.length; j++) {
                if (this.threeYard[i] == this.bgArr[j].type) {
                    this.bgArr[j].color = "#1CA4B6"
                    // this.bgArr[j].fontSize = "20"
                }
            }
        }

          for(var i = 0;i<this.bgNewArr.length;i++){
            this.bgArr.forEach((item) => {
             
              if(this.bgNewArr[i] == item.name){
                this.bgNewArr2.push(item)
              }
            })
          }
          for(var i = 0;i<this.bgNewArr2.length;i++){
              this.radarValue.push(this.bgNewArr2[i].value)
          }

         
          this.$nextTick(()=>{
            
           //  this.drawBagua(this.bgNewArr2);
          })
        }else{
        }
      })
    },
     drawBagua(value) {
      var echarts2 = require("echarts");
      var myChart2 = echarts2.init(document.getElementById("Gossip"));
      var iarr = []
      myChart2.setOption(
        {
        tooltip: {
          trigger: "item",
        },
        radar: {
          // shape: 'circle',
          name: {
            formatter: function (val) {
                          
                            let values = false
                            for (let i = 0; i < value.length; i++) {
                                if (value[i].name == val && value[i].color) {
                                    values=true
                                   break
                                }
                            }
                            if(values){
                                return '{a|' + val + '}'
                            }else{
                                return '{b|' + val + '}'
                            }
                           
                        },
           
            rich: {
              a: {
                 color: "#1CA4B6",
                fontSize: 18,
              },
              b: {
                color: "#2F2F2F",
                fontSize: 14,
               
              },
            },
            textStyle: {
              color: "#4D4D4D",
              fontSize: 14,
              fontWeight: "bold",
              padding: [3, 5],
            },
          },

          axisLine: {
            //指向外圈文本的分隔线样式
            lineStyle: {
              type: "dashed",
            },
          },
          splitArea: {
            show: true,
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
            },
          },
          radius: "70%",
          center: ["50%", "50%"],
          // indicator: this.bgArr,
          indicator:value
        },
        series: [
          {
            name: "测评结果",
            type: "radar",
            // areaStyle: {normal: {}},
            data: [
              {
                value: this.radarValue,
                name: "测评结果",
                label: {
                  show: true,
                  formatter: function (params) {
                    iarr.push(params)
                    // if (params.value <= 10) {
                    //   return "{a|" + params.value + "}";
                    // } else {
                    //   return "{b|" + params.value + "}";
                    // }
                    for (var i = 0; i < value.length; i++) {
                                if (value[i].value == params.value && value[iarr.length - 1].color) {
                                    return '{b|' + params.value + '}';
                                }



                            }
                  },
                  rich: {
                    a: {
                      color: "#2F2F2F",
                      fontSize: 14,
                    },
                    b: {
                      color: "#1CA4B6",
                      fontSize: 18,
                    },
                  },
                },
              },
            ],
            areaStyle: {
              color: "rgba(184,232,255,0.8)",
            },
            lineStyle: {
              color: "#1CA4B6",
              width: 2,
            },
            label: {
              show: true,
              position: "top",
              fontSize: 14,
              color: "#2F2F2F",

              // fontWeight:'bold'
            },
            symbol: "circle",
            symbolSize: 4,
            showAllSymbol: false,

            itemStyle: {
              color: "white",
              borderColor: "#1CA4B6",
              borderWidth: 2,
            },
          },
        ],
      });
    },
  },
  mounted() {
    this.toParent()
    // this.getReportId()
    this.judgeNewOld()
    
  }
}
</script>

<style  lang="less" scoped>
.noContent{
  background: #fff;
  min-height: 600px;
}
.addBox {
    min-height: 600px;
    padding-top: 80px;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    background: #fff;
    .add {
        cursor: pointer;
        img {
            margin-bottom: 20px;
            display: block;
            margin: 0 auto;
        }
        p {
            line-height: 30px;
            font-size: 16px;
            span {
                color: #2BA6EE;
                cursor: pointer;
            }
        }
    }
}
  .evaluationPeport_main{
    // width: 1050px;
    margin:0 auto;
    background: #fff;
    padding: 20px 90px  50px;
    .title{
      font-size: 32px;
      font-weight: bolder;
      line-height: 80px;
      text-align: center;
      color:#0094EA;
    }
    .partTitle{
      font-size: 24px;
      color:#2F2F2F;
      padding: 30px 0 ;
    }
    .evaluation_button{
        width: 78px;
         margin: 0 auto;
        border-radius: 16px;
        text-align: center;
        line-height: 32px;
        font-size: 16px;
        cursor: pointer;
        background: #ECF8FE;
        color: #1EA2EE;
        border: 1px solid #76C6F4;
        padding: 0 20px;
        box-sizing: border-box;
        &:hover{
          background: #099BEF !important;
          color: #fff !important;
        }
      }


  }
</style>